<template >
<div >
    <v-layout v-if="!page_show">
        <not-page-spinner :not_show="true" /> 
    </v-layout>  
    <v-container v-else grid-list-l> 
        <v-row> 
            <v-col sm="6" md="4" cols="12" v-for="(item, index) in p_images?p_images.list:null" :key="index" class="px-1">
                <v-hover v-slot:default="{hover}">
                    <v-card 
                        :to="'/gallery/'+item.key" flat="" 
                        color="" height="100%" 
                        hover=""  class="px-" outlined="">
                        <v-img v-if="!item.image"
                            :src="not.noImg"
                            :lazy-src="not.imgLazy"
                            aspect-ratio="1.5"
                            class="grey lighten-2"/>
                        <v-img v-else
                            :src="item.image.link"
                            :lazy-src="not.imgLazy"
                            aspect-ratio="1.5"
                            class="grey lighten-2"/>   
                        <v-card-title >
                            {{item.name}}
                        </v-card-title> 
                    </v-card>
                </v-hover> 
            </v-col> 
        </v-row> 
         
       
        <br>
        <v-divider></v-divider>
        <div class="px-5">
            <v-pagination
                v-model="page_current"
                class="mt-4"
                :length="p_images?p_images.pages:0"/> 
        </div>
    </v-container>
   
</div>
</template>

<script>
    let pageName = "News"
    export default{
        props:["id","not"],
        name: pageName,  
        data: () => ({
            page_show: false,   
            page_current:1,
            page_size:12,
            images:[
                {src:'/images/teresian/t2.JPG',local:true},    
            ],
            items:[
                {title:"",body:"",link:"./images/teresian/t1.JPG"},
                {title:"",body:"",link:"./images/teresian/t2.JPG"},
                {title:"",body:"",link:"./images/teresian/t3.JPG"},
                {title:"",body:"",link:"./images/teresian/t4.JPG"},
                {title:"",body:"",link:"./images/teresian/t5.JPG"},
                {title:"",body:"",link:"./images/teresian/t6.JPG"},
                {title:"",body:"",link:"./images/teresian/t7.JPG"},
                {title:"",body:"",link:"./images/teresian/t8.JPG"},
                {title:"",body:"",link:"./images/teresian/t9.JPG"},
                {title:"",body:"",link:"./images/teresian/t10.JPG"},
                {title:"",body:"",link:"./images/teresian/t11.JPG"},
                {title:"",body:"",link:"./images/teresian/t12.JPG"},
                {title:"",body:"",link:"./images/teresian/t13.JPG"},
                {title:"",body:"",link:"./images/teresian/t14.JPG"},
                {title:"",body:"",link:"./images/teresian/t15.JPG"},
                {title:"",body:"",link:"./images/teresian/t16.JPG"},
                {title:"",body:"",link:"./images/teresian/t17.JPG"},
                {title:"",body:"",link:"./images/teresian/t18.JPG"},
                {title:"",body:"",link:"./images/teresian/t19.JPG"},
                {title:"",body:"",link:"./images/teresian/t20.JPG"},
            ]
           
        }),
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"image",
                notImages:this.images,
                notText:false,
                notIndicators:true,
                notHeight:350
            })
            this.pageLoad(500)
        },
        //---------computed-----------
        computed: { 
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            }, 
            imagesItems(){
                return this.items
            }, 
            galleryItem(){
                return this.$store.getters.getGalleryItem
            },
            p_images(){
                let images = this.galleryItem
                if (!images) {
                    return null
                }
                let list = [...images] 
                list.sort(this.not.dynamicSort("title",false)) 
                return this.not.pagination(list,this.page_current,this.page_size)
            }, 
        },

        //--------methods-----------
        methods:{
             
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //CHECK USER STATE
                    if (ps.indexOf('logging')!==-1) { 
                        this.page_show = false
                    } else {   
                        this.page_show = true
                    } 

                    //Check proccess 
                    if (ps.indexOf('add/bibleStudy')!==-1) {
                        this.not.notDialogP(true,true,'adding...') 
                    }else{
                        this.not.notDialogP(false) 
                    }  

                    if (ps.indexOf('delete/bibleStudy')!==-1) {
                        this.not.notDialogP(true,true,'delete...') 
                    }else{
                        this.not.notDialogP(false) 
                    } 

                    //check response
                    if (res.res==='add/bibleStudy/successful') { 
                        this.not.notDialog(true,true,'Successful','Bible study, successfuly added.','','OK',{code:2}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='add/bibleStudy/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding bible study.','Cancel','Try again',{code:3}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }

                    if (res.res==='delete/bibleStudy/successful') { 
                        this.not.notDialog(true,true,'Successful','Bible study, successfuly deleted.','','OK',{code:5})
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='delete/bibleStudy/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting bible study.','Cancel','Try again',{code:5}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }
                },t)
            }
        }, 
        watch: {
            us(v){
                 
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>

 